import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import Home from '../../components/home/Home';
import PageWrapper from '../../components/shared/PageWrapper';

class HomeContainer extends Component {
	render() {
		const { match } = this.props;
		return <PageWrapper
			match = { match }
		>
			<Home 
				routeTrigger = { this.routeTrigger }
			/>
		</PageWrapper>
	}

	routeTrigger = (routeName) => (e) => {
		const { routeTrigger } = this.props;
		routeTrigger(routeName);
	}
}
function mapStateToProps(state) {
	return {
		
	}
}

const mapDispatchToProps = dispatch => {
	return {
		routeTrigger: (routeName) => {
			dispatch(actions.routing.routeTrigger(routeName));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);


// WEBPACK FOOTER //
// ./src/containers/home/HomeContainer.jsx